<template>
  <mdb-container>
    <div v-for="region in regions" :key="region">
      <div v-if="getCountriesByRegion(region).length">
        <div class="heading-region">
          {{ region }}
        </div>
        <div class="card-columns ">
          <div
            v-for="(item, key) in getCountriesByRegion(region)"
            :key="key"
            :class="{
              card: true,
              hoverable: true,
              'mt-2': true,
              'mb-3': true,
              'selected-card animated shake delay-2s': item.iso_code == isoCode
            }"
          >
            <div class="card-body" :id="item.iso_code">
              <div class="text-left title base-color ">
                {{ item.name }}

                <span class="heading-isoCode">
                  {{ convertIsoCode(item.iso_code) }}
                </span>
              </div>

              <hr />
              <div
                class="card-text text-left "
                v-for="operator in Object.keys(
                  item.operatorsMapServices
                ).sort()"
                :key="operator"
              >
                <div
                  v-for="service in item.operatorsMapServices[operator]"
                  :key="service"
                >
                  <p
                    v-if="
                      (mapFilters['services'].length != 0 &&
                        mapFilters['services'].includes(service)) ||
                        mapFilters['services'].length == 0
                    "
                  >
                    {{ operator }}
                    <mdb-tooltip
                      trigger="hover"
                      :options="{ placement: 'left' }"
                    >
                      <span slot="tip">
                        {{ service }}
                      </span>
                      <a slot="reference">
                        <mdb-icon
                          class="panel-icon"
                          :icon="icons[service.toLowerCase().replace(' ', '')]"
                      /></a>
                    </mdb-tooltip>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mdb-container>
</template>

<script>
import { mdbTooltip } from "mdbvue";
import { getCurrentMapProducts } from "../common/utilities/mapController.js";
import { MAPPING_ISO_CODE, ICONS } from "../common/constants.js";
import {
  getProducts,
  getRegions
} from "../common/dataSourceIntegrationService";
import { sortWithName } from "../common/utilities/helpers";
export default {
  name: "ContriesList",
  data() {
    return {
      items: getProducts(),
      icons: ICONS,
      regions: [],
      mapFilters: this.$store.getters.mapFilters
    };
  },
  created() {
    getRegions().forEach(element => {
      this.regions.push(element.name);
    });
  },
  computed: {
    isoCode: function() {
      return this.$route.params.isoCode;
    }
  },
  methods: {
    update() {
      this.items = getCurrentMapProducts();
    },
    getCountriesByRegion(region) {
      let regionCountries = Object.values(this.items).filter(item => {
        return item.region == region;
      });

      return sortWithName(regionCountries);
    },
    convertIsoCode(isoCode3) {
      return MAPPING_ISO_CODE[isoCode3];
    }
  },
  components: {
    mdbTooltip
  }
};
</script>
<style lang="scss" scoped>
.row {
  background-color: #f0f5f7;
}
.card {
  box-shadow: 0 2px 10px rgba(0,0,0,.17);
  border-radius: 10px;
  &:hover,
  &:active,
  &:focus {
    box-shadow: 0 2px 10px rgba(0,0,0,.33);
  }
  .card-body {
    padding: 1.5rem 1.25rem .5rem;
  }
}
.selected-card {
  background-color: #5586ab;
  .title, p, .panel-icon {
    color: #fff;
  }
}
.title {
  text-transform: uppercase;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 1em;
  line-height: 1em;
  font-weight: 800;
  .heading-isoCode {
    float: right;
    font-weight: 300;
  }
}

%heading {
  padding-bottom: 10px;
  border-bottom: 1px none #d5e3ed;
  color: #8fa3b3;
  font-size: 1.8rem;
  line-height: 40px;
  font-weight: 300;
  text-align: center;
  letter-spacing: 1px;
  text-transform: uppercase;
}
.heading-region {
  @extend %heading;
  font-size: 2em;
  padding: 30px 0 10px;
  line-height: 48px;
}
hr {
  margin: 10px 0 15px;
}
</style>
